/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRoleAutocompleteSuggestion } from './APIRoleAutocompleteSuggestion';
import {
    APIRoleAutocompleteSuggestionFromJSON,
    APIRoleAutocompleteSuggestionFromJSONTyped,
    APIRoleAutocompleteSuggestionToJSON,
} from './APIRoleAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIRoleAutocompleteResponse
 */
export interface APIRoleAutocompleteResponse {
    /**
     * 
     * @type {Array<APIRoleAutocompleteSuggestion>}
     * @memberof APIRoleAutocompleteResponse
     */
    suggestions: Array<APIRoleAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIRoleAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIRoleAutocompleteResponse interface.
 */
export function instanceOfAPIRoleAutocompleteResponse(value: object): value is APIRoleAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIRoleAutocompleteResponseFromJSON(json: any): APIRoleAutocompleteResponse {
    return APIRoleAutocompleteResponseFromJSONTyped(json, false);
}

export function APIRoleAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRoleAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIRoleAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIRoleAutocompleteResponseToJSON(value?: APIRoleAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIRoleAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

